"use strict";

export default function getContext(){
    if(window.chrome && chrome.app && chrome.app.runtime){
        return "chromeapp";
    }
    else{
        return "browser";
    }
}


// WEBPACK FOOTER //
// ./~/vwa/getContext.js